import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PauseCircleOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pause_circle_outline"}/>
}
